<template>
  <vx-card title="Push History">
    <vs-collapse type="border">
      <vs-collapse-item v-for="log in logs" :key="log._id">
        <div slot="header">
          <b>{{ log.senderName }}</b> - {{ moment(log.createdAt).format('MM-DD-YYYY hh:mm A') }}
        </div>
        <vs-list>
          <vs-list-item title="Message Title" :subtitle="log.messageTitle || 'NA'" />
          <vs-list-item title="Message Body" :subtitle="log.messageBody || 'NA'" />
          <vs-list-item title="Web Link" :subtitle="log.webLink || 'NA'"></vs-list-item>
          <vs-list-item v-if="log.userIds.length" title="UserIds" :subtitle="log.userIds.join(', ') || 'NA'" />
          <vs-list-item v-else title="Filters" :subtitle="log.filters.join(', ') || 'NA'" />
        </vs-list>
      </vs-collapse-item>
    </vs-collapse>
  </vx-card>
</template>

<script>
  import api from '@/http/api';
  import moment from 'moment';

  export default {
    data() {
      return {
        logs: []
      }
    },
    mounted() {
      this.fetch();
    },
    methods: {
      moment: moment,
      async fetch() {
        this.logs = await api.getAllPushNotificationLogs();
      }
    }
  }
</script>
